import RoundButton from '../components/RoundButton';
import Page from '../components/Page';
import { useAppStore } from '../stores/useAppStore';
import { AnimatePresence, motion } from 'motion/react';
import useMenuNavigation from '../hooks/useMenuNavigation';

function Home() {
  const { content } = useAppStore();
  const navigateTo = useMenuNavigation();

  const items = content?.homepage?.menu;

  const handleButtonClick = (key) => {
    navigateTo(key);
  };

  return (
    <Page className='flex space-between gap-10 pl-64 pr-[13.75rem] overflow-hidden'>
      <div className='flex flex-wrap gap-x-[9rem] gap-y-[13rem] content-center justify-center overflow-hidden relative'>
        <AnimatePresence>
        {items.map((item, index) => (
          <RoundButton
            key={item.key}
            index={index}
            color={item.color}
            onClick={() => handleButtonClick(item.key)}
            >
              <div className='
              flex
              items-center
              justify-center
              content-center
              flex-col
              w-full
              h-full
              p-20
              font-extralight
              text-center'>
                  <span className='text-[4.625rem] block leading-[6rem]'>{item.header}</span>
            </div>
              
          </RoundButton>
        ))}
        </AnimatePresence>

        <AnimatePresence>
          <motion.div className='flex-1 p-1 content-center font-extralight absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'
            initial={{opacity: 0, filter: "blur(5px)"}}
            animate={{opacity: 1, filter: "blur(0px)"}}
            transition={{duration: 1, delay: 2}}
          >
            <h3 className='text-[2.75rem] leading-none tracking-[0.825rem] text-[#213A70]'>{content?.homepage.tip}</h3>
          </motion.div>
        </AnimatePresence>
      </div>
      
    </Page>
  );
}

export default Home;